import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '10px',
      justifyContent: 'center',
      alignItems: 'center'
    },
    percent: {
      fontSize: '1.25rem'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
